module.exports = __webpack_public_path__ + "static/media/plus-add-new-svgrepo-com.c8a8b499.svg";